import "./sellscreenerrors.scss";
import * as React from "react";
import BackButton from "../../../Common/Buttons/BackButton";
import RetryButton from "../../../Common/Buttons/RetryButton";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    onRetry?: () => void;
    onBack?: () => void;
    heading?: React.ReactNode;
    children?: React.ReactNode;
}

export default class GeneralSellScreenError extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <div className="general-sell-screen-error">
                <div className="general-sell-screen-error-inner">
                    <div className="general-error-icon">
                        <FontAwesomeLight icon="meh" />
                    </div>
                    <div className="general-error-heading">
                        {this.props.heading ? this.props.heading : (
                            <h3>An error occurred!</h3>
                        )}
                    </div>
                    <div className="general-error-body">
                        {this.props.children ? this.props.children : (
                            <p>We&apos;ve encountered an error an were unable to render the component.</p>
                        )}
                    </div>
                    {(this.props.onRetry || this.props.onBack) && (
                        <div className="general-error-buttons">
                            {this.props.onBack && (
                                <BackButton onClick={this.props.onBack} />
                            )}
                            {this.props.onRetry && (
                                <RetryButton onClick={this.props.onRetry} />
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
